module.exports = __webpack_public_path__ + "d12ca15538d91ac8477ab8c8de782b74.png";